var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-wrap",staticStyle:{"width":"100%","height":"100%"}},[_c('canvas',{ref:"cvs",staticClass:"vf-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }